import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "American resolve.\nMiddle Eastern fluency.",
    body:
      "Mends International Group is a US-based partner for organizations working where the map gets complicated. Our leadership sits in the United States. Our operators, engineers, and trading houses are already on the ground — trusted in Iraq, Jordan, and across the Gulf.",
  },
  {
    n: "02",
    title: "One relationship.\nEvery discipline.",
    body:
      "Executive protection. Convoy and static security. Life support for bases. Industrial supply and engineering execution. Aviation ground handling. Under one master services relationship — because the last thing our clients need is another vendor stack.",
  },
  {
    n: "03",
    title: "Operations support.\nSerious capability.",
    body:
      "In Jordan, our partnership puts twenty years of industrial supply, engineering, and airport logistics behind every project. In Beijing, our EPC partnership brings refinery and petrochemical engineering pedigree. You see one team; you get all of them.",
  },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};
const item = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export default function Manifesto() {
  return (
    <section id="about" className="relative py-32 md:py-48" data-testid="manifesto">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center gap-4 mb-20"
        >
          <span className="h-px w-10 bg-gold" />
          <span className="overline">The Manifesto</span>
        </motion.div>

        <div className="flex flex-col gap-32 md:gap-40">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              variants={container}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-120px" }}
              className={`grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start`}
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <motion.div variants={item} className="md:col-span-4 relative">
                <div className="sticky top-32">
                  <div className="font-display text-[120px] md:text-[180px] leading-[0.9] text-gold/90">
                    {c.n}
                  </div>
                  <div className="mt-4 font-mono text-[11px] tracking-[0.3em] uppercase text-white/50">
                    Chapter {i + 1} · 03
                  </div>
                </div>
              </motion.div>

              <motion.div variants={item} className="md:col-span-8 md:pt-6">
                <h3 className="h-display text-3xl md:text-5xl whitespace-pre-line">
                  {c.title}
                </h3>
                <div className="mt-8 flex items-start gap-6 border-l border-navy-border pl-8">
                  <p className="text-white/70 text-base md:text-lg leading-[1.85] max-w-2xl">
                    {c.body}
                  </p>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
